import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var DotsSvg = function DotsSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M9 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M10.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M10.5 18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    })
  });
};
export var Dots = function Dots(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: DotsSvg
  }));
};